"use strict";
/**
 * @module Services.Send
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../io/codec");
var serialiser_1 = require("./../serialisers/serialiser");
var count_or_parser_errors_1 = require("./../services/count-or-parser-errors");
var error_report_serialiser_1 = require("./../services/error-report-serialiser");
/**
 * Serialiser for {@link CountOrParserErrors}.
 */
var CountOrParserErrorsSerialiserClass = /** @class */ (function (_super) {
    __extends(CountOrParserErrorsSerialiserClass, _super);
    function CountOrParserErrorsSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link CountOrParserErrors} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link CountOrParserErrors} that was read
     */
    CountOrParserErrorsSerialiserClass.prototype.read = function (bis) {
        var count = Codec.readInt32(bis);
        var errors = Codec.readCollection(bis, error_report_serialiser_1.ErrorReportSerialiser.read);
        return new count_or_parser_errors_1.CountOrParserErrors(count, errors);
    };
    /**
     * Write a {@link CountOrParserErrors} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link CountOrParserErrors} to be written
     */
    CountOrParserErrorsSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeInt32(bos, value.count);
        Codec.writeCollection(bos, value.errors, error_report_serialiser_1.ErrorReportSerialiser.write);
    };
    return CountOrParserErrorsSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.CountOrParserErrorsSerialiserClass = CountOrParserErrorsSerialiserClass;
/**
 * The {@link CountOrParserErrorsSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.CountOrParserErrorsSerialiser = new CountOrParserErrorsSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/count-or-parser-errors-serialiser.js
// module id = 1278
// module chunks = 1